import { IWhere2goState, SET_DATE, SET_PERIOD, SET_RADIUS, SET_WHERE2GO } from "../actions/where2go";
import { updateState } from "../StoreFactory";
import { ActionType } from "../../interfaces/storeFactory";
import { combineReducers } from "redux";


export interface IWhere2goStore {
    where2go: IWhere2goState
}

export const initialState = {
    where2go: {
        date: 1,
        period: 2,
        radius: 60,
    }
}

export const where2go = (state = initialState.where2go, action: ActionType<any>): IWhere2goState => (
    updateState(state, action, [SET_DATE, SET_PERIOD, SET_RADIUS, SET_WHERE2GO])
)

export default combineReducers({ where2go })